import { render, staticRenderFns } from "./MatchHeaders.vue?vue&type=template&id=b0c771a6&"
import script from "./MatchHeaders.vue?vue&type=script&lang=js&"
export * from "./MatchHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports